import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-flex-reasontiles',
    templateUrl: './block-flex-reasontiles.component.html',
})

export class BlockFlexReasontilesComponent extends BlockAbstractComponent implements OnInit {

}
